import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { api, errMsg } from "@/lib/api";
import { useData } from "@/context/DataContext";

export const DeleteLeadButton = ({ lead }) => {
  const { removeLead, closeEditor } = useData();
  const confirm = async () => {
    try {
      await api.delete(`/leads/${lead.id}`);
      removeLead(lead.id);
      closeEditor();
      toast.success(`${lead.name} deleted`);
    } catch (e) {
      toast.error(errMsg(e, "Delete failed"));
    }
  };
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button type="button" data-testid="editor-delete-btn" className="btn-ghost text-slate-400"><Trash2 className="h-4 w-4" /> Delete</button>
      </AlertDialogTrigger>
      <AlertDialogContent className="max-w-[calc(100vw-2rem)] rounded-2xl border-slate-800 bg-slate-900 text-slate-100 sm:max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle>Delete {lead.name}?</AlertDialogTitle>
          <AlertDialogDescription>This removes the card from the board and the Lead Log. It cannot be undone.</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="delete-lead-cancel-btn">Cancel</AlertDialogCancel>
          <AlertDialogAction data-testid="delete-lead-confirm-btn" onClick={confirm} className="bg-indigo-600 text-white hover:bg-indigo-500">Delete lead</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
